type SortType = "ASC" | "DESC";

const compareValues = (a: unknown, b: unknown): number => {
  if (a == null && b == null) return 0;
  if (a == null) return -1;
  if (b == null) return 1;

  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    return a.join(", ").localeCompare(b.join(", "), "ru", { numeric: true });
  }

  return String(a).localeCompare(String(b), "ru", { numeric: true });
};

export const sortItems = <T>(
  items: T[],
  sortField?: string,
  sortType?: SortType | string,
  getValue: (item: T, field: string) => unknown = (item, field) =>
    (item as Record<string, unknown>)[field],
): T[] => {
  if (!sortField || (sortType !== "ASC" && sortType !== "DESC")) {
    return items;
  }

  const direction = sortType === "ASC" ? 1 : -1;

  return [...items].sort(
    (left, right) =>
      direction *
      compareValues(getValue(left, sortField), getValue(right, sortField)),
  );
};
